module.exports = __webpack_public_path__ + "static/1-Clubhouse-Lobby-Image-0cc44be2b3fe3644125bd9168cc62f08.jpg";